import { Component } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-production-status',
  templateUrl: './production-status.component.html',
  styleUrls: ['./production-status.component.css']
})
export class ProductionStatusComponent {
    public barcodeButtons: FormButton[] = [{ id: 'search', type: 'success', icon: 'fas fa-search', onClick: () => this.findItem() }];

    public barcode: string = '';

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async findItem() {
        if (!!this.barcode) {
            const response = (await this.datatask.Post(394, { barcode: this.barcode }))[0];

            if (response) {
                this.stateService.go(response?.webpagename, response?.parms);
                this.clear('barcode');
            } else {
                this.clear('barcode');
            }
        }
    }

    private clear(id: string) {
        if (!this.barcode) return;

        switch (id) {
            case 'barcode':
                if (this.barcode !== '') {
                    this.barcode = '';
                }
                break;
            default:
                break;
        }
    }

    public searchItem() {
        this.findItem();
    }
}
